export default __webpack_public_path__ + "static/media/login-7.24998108.svg";